var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExternalLink = function SvgExternalLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 4h-6.8c-1.2 0-1.8.8-1.8 1.8s.8 1.8 1.8 1.8h2.4l-11.2 11c-.8.8-.8 1.8 0 2.4.8.8 1.8.8 2.4 0l11-11v2.4c0 1 .8 1.8 1.8 1.8s1.8-.8 1.8-1.8V5.6c0-1.4-.8-1.6-1.4-1.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9 20c-1 0-1.8.8-1.8 1.8v2.8H7.5V10h2.8c1.2 0 1.8-.8 1.8-1.8s-.6-1.8-1.6-1.8H5.7c-1 0-1.8.8-1.8 1.8v18c0 1 .8 1.8 1.8 1.8h18c1 0 1.8-.8 1.8-1.8v-4.6c.2-1-.6-1.6-1.6-1.6"
  })));
};
export default SvgExternalLink;